import { DatePicker, Button } from "antd";
import TableMap from "../Components/TableMap";
import DateTimePicker from "../Components/DateTimePicker";
import Counter from "../Components/Counter";
import DataUserLoyalty from "../store/DataUserLoyalty";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";

const Reservation = observer(() => {
    const navigation = useNavigate();
    useEffect(() => {
        if (
            localStorage.getItem("user") == "undefined" ||
            localStorage.getItem("user") == null
        ) {
            navigation(
                `/userLoyalty/registration${
                    DataUserLoyalty.placeId
                        ? `?place_id=${DataUserLoyalty.placeId}`
                        : ""
                }`
            );
        }
    }, []);
    const handleDateTimeChange = (value) => {
        console.log("Выбранная дата и время:", value); // Пример: 2025-06-19T14:30
    };
    return (
        <div className='px-[14px] py-[32px] flex flex-col justify-between h-[100vh]'>
            <div className='mb-[24px]'>
                <div className='mb-[24px]'>
                    <p className='text-[24px] font-bold text-left mb-[24px]'>
                        Забронировать стол
                    </p>

                    <DateTimePicker onChange={handleDateTimeChange} />
                </div>

                <div className='flex justify-between gap-[6px] mb-[24px]'>
                    <div className='w-full'>
                        <p className='mb-[2px] text-[12px] text-left font-[600] text-gray-700 '>
                            Количество гостей
                        </p>
                        <Counter />
                    </div>
                    <div className='w-full'>
                        <p className='mb-[2px] text-[12px] text-gray-700 text-left font-[600]'>
                            Продолжительность
                        </p>
                        <Counter />
                    </div>
                </div>
                <div>
                    <p className=' text-left font-[600] text-[16px] '>
                        Доступные столы
                    </p>
                    <div className='flex gap-[6px] mb-[20px]'>
                        <button
                            onClick={() => {
                                DataUserLoyalty.tableSide = "ЛЕТНИК";
                            }}
                            className={`text-[14px] font-[600] rounded-[16px] px-4 py-[3px] border transition duration-100 
                                        touch-none focus:outline-none active:scale-[0.97]
                                        ${
                                            DataUserLoyalty.tableSide ===
                                            "ЛЕТНИК"
                                                ? "bg-[#1890FF] text-white border-none"
                                                : "bg-white text-[#1890FF] border border-[#1890FF] hover:bg-[#e6f4ff]"
                                        }`}
                            style={{ WebkitTapHighlightColor: "transparent" }}>
                            Летняя терраса
                        </button>
                        <button
                            onClick={() => {
                                DataUserLoyalty.tableSide = "Зал";
                            }}
                            className={`text-[14px] font-[600] rounded-[16px] px-4 py-[3px] border transition duration-100 
                                        touch-none focus:outline-none active:scale-[0.97]
                                        ${
                                            DataUserLoyalty.tableSide === "Зал"
                                                ? "bg-[#1890FF] text-white border-none"
                                                : "bg-white text-[#1890FF] border border-[#1890FF] hover:bg-[#e6f4ff]"
                                        }`}
                            style={{ WebkitTapHighlightColor: "transparent" }}>
                            Зал
                        </button>
                    </div>
                </div>

                <div className='border-gray-400 border-[1px] rounded-[8px] p-[10px]'>
                    <TableMap />
                </div>
            </div>
            <div>
                <button className=' bg-blue-500 w-full text-white py-[7px] rounded-[7px] mb-[24px]'>
                    Забронировать
                </button>
            </div>
        </div>
    );
});

export default Reservation;
